<div
  class="card-container"
  [class.info]="messageType() === 'info'"
  [class.warning]="messageType() === 'warning'"
  [class.success]="messageType() === 'success'"
  [class.error]="messageType() === 'error'">
  <mat-icon class="msg-icon">{{ messageType() === 'success' ? 'check_circle' : messageType() }}</mat-icon>
  <p>
    <ng-content></ng-content>
  </p>
</div>
